import React from 'react';
import Sale from "../../../components/lotto99/mobile/Sale";
import MainLotto99Wrapper from "../../../components/lotto99/MainLotto99Wrapper";

const Lotto99Mobile = () => {
    return (
        <div className="main-w">
            <div className="main">
                <div className="w-1200">
                    <div className="lo90-v1-wap wrapper-new-lotto90 lotto90">
                        <MainLotto99Wrapper>
                            <Sale />
                        </MainLotto99Wrapper>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Lotto99Mobile;